module.exports = __webpack_public_path__ + "img/curious_addys_tab.870234f3.png";